import type { ReactNode } from "react";

export function PageHead({ title, aside }: { title: string; aside?: ReactNode }) {
  return (
    <header className="page-head">
      <h1 className="page-title">{title}</h1>
      {aside === undefined ? null : <div className="page-head-aside">{aside}</div>}
    </header>
  );
}
